"use client";

import { Compass } from "lucide-react";
import { EmptyState } from "@/components/ui/EmptyState";
import { useUi } from "@/components/ui/use-ui";

/** The site's 404 message in the page's language (not-found pages get no params, so it reads them here). */
export function NotFoundView() {
  const t = useUi().notFound;
  return (
    <EmptyState icon={<Compass size={26} />} title={t.title} action={{ href: "/", label: t.home }}>
      {t.body}
    </EmptyState>
  );
}
